/**
 * supabase.js
 * Cliente de Supabase compartido por toda la app.
 * Se importa desde cualquier módulo que necesite
 * acceder a la base de datos o a la autenticación.
 */

import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(url, key);